import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_page = _resolveComponent("page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.table,
        stripe: "",
        "empty-text": "没有记录",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            type: "index",
            label: "序号",
            width: "50"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "title",
            label: "新闻标题",
            "min-width": "160"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "url",
            label: "新闻来源",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("a", {
                href: scope.row.url,
                target: "_blank"
              }, _toDisplayString(scope.row.source), 9, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "publishTime",
            label: "发布时间"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toDate(scope.row.publishTime,'YYYY-MM-DD')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "emotionType",
            label: "情感类型"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "newsTags",
            label: "新闻标签"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.ckInfo(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: _ctx.d.content
          }, null, 8, _hoisted_4)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_page, {
      currentPage: _ctx.pageIndex,
      pageSize: _ctx.pageSize,
      pages: _ctx.pageCount,
      onChangePage: _ctx.changePage
    }, null, 8, ["currentPage", "pageSize", "pages", "onChangePage"])
  ], 64))
}